import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { horizontalNavJiraResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/horizontal-navigation/horizontal-nav-jira/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { legacyProjectReleasesNoteConfigRoute } from '@jira/router-routes__legacy-project-releases-note-config-routes/src/legacyProjectReleasesNoteConfigRoute.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import type { RouteResources } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const legacyProjectReleasesNoteConfigRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(legacyProjectReleasesNoteConfigRoute, () => ({
		layout: genericProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
		},

		resources: [
			...getBusinessProjectResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			horizontalNavJiraResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			getConsolidationStateResource(),
		],

		entryPoint: () => pageEntryPoint,
	}));
